import { render, staticRenderFns } from "./ManualProducts.vue?vue&type=template&id=7047d9ba&"
import script from "./ManualProducts.vue?vue&type=script&lang=js&"
export * from "./ManualProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports